import * as React from 'react';
import { classNames, analyticsTracker } from 'uitk-react-utils';
import styles from './uitk-header-brand-logo.css';
var _this = undefined;
var getClassNameList = classNames.bind(styles);
var UitkHeaderBrandLogo = function (props) {
  var imgSrc = props.imgSrc,
    href = props.href,
    altText = props.altText,
    analytics = props.analytics;
  return React.createElement("a", {
    className: getClassNameList('uitk-header-brand-logo'),
    href: href || '/',
    "data-testid": "header-brand-logo-anchor",
    onClickCapture: analytics && analyticsTracker.bind(_this, analytics)
  }, React.createElement("img", {
    src: imgSrc,
    alt: altText
  }));
};
UitkHeaderBrandLogo.displayName = 'UitkHeaderBrandLogo';
export { UitkHeaderBrandLogo };